// recovery-v2.js — Entrypoint for the React password-recovery page
// (Recovery-V2). Mounts into `#js--recovery-v2` at the existing
// `/authorization/recovery/` URL, which the homepage already links to, so no
// homepage change is needed. The emailed link lands on the same URL with a
// token segment, which the page reads to switch into its reset state.
import React from 'react';
import { createRoot } from 'react-dom/client';

import '../configs/bootstrap-ui.js';

import ErrorHandler from '../modules/error/error-handler.screen.js';
import RecoveryPage from '../modules/recovery/RecoveryPage.js';

const rootEl = document.getElementById('js--recovery-v2');
if (rootEl) {
	const root = createRoot(rootEl);
	root.render(
		<ErrorHandler>
			<RecoveryPage token={rootEl.dataset.token || ''} />
		</ErrorHandler>
	);
}
